import React from 'react';
import { Color } from '../../const/Const';

const GridFooter = (props) => {
    return (
        <div style={{ fontWeight: 600, fontSize: 13, color: Color.backText }}>
            {props.children}
        </div>
    );
}
export default GridFooter;